// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","title":"settings_title__u_QWx","timezone-scroll-bar":"settings_timezone-scroll-bar__2n1JZ"};